export const FETCH_ALL_FEATURE = 'fetch_all_feature';
export const FETCH_ALL_FEATURE_SUCCESS = 'fetch_all_feature_success';
export const EDIT_FEATURE = 'edit_feature';
export const DELETE_FEATURE = 'delete_feature';
export const CREATE_FEATURE = 'create_feature';
export const CREATE_FEATURE_SUCCESS = 'create_feature_success';
export const UPDATE_FEATURE_SUCCESS = 'update_feature_success';
export const UPDATE_FEATURE = 'update_feature';
export const DELETE_FEATURE_SUCCESS = 'delete_feature_success';
export const SET_FEATURE = 'set_feature';
export const SET_ROLE = 'set_role';